import "core-js/modules/es.object.to-string.js";
import { loginByCode } from '@/api/module/auth';
import { getUserAllInfo as _getUserAllInfo } from '@/api/module/user';
import { saveToken, saveLoginStatus, saveUserInfo, removeToken, removeUserInfo, removeLoginStatus, loadLoginStatus, loadToken, loadUserInfo } from '@/assets/utils/cache';
var state = {
  loginStatus: loadLoginStatus(),
  // 登录状态
  token: loadToken(),
  // token
  userInfo: loadUserInfo() // 用户登录信息

};
var mutations = {
  SET_USERINFO: function SET_USERINFO(state, userInfo) {
    state.userInfo = userInfo;
  },
  SET_LOGIN_STATUS: function SET_LOGIN_STATUS(state, loginStatus) {
    state.loginStatus = loginStatus;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  }
};
var actions = {
  // 登录相关，通过code获取token和用户信息
  loginWechatAuth: function loginWechatAuth(_ref, code) {
    var commit = _ref.commit;
    var data = {
      code: code
    };
    return new Promise(function (resolve, reject) {
      loginByCode(data).then(function (res) {
        // 存用户信息，token
        commit('SET_USERINFO', saveUserInfo(res.data));
        commit('SET_TOKEN', saveToken(res.data.token));
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getUserAllInfo: function getUserAllInfo(_ref2) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      _getUserAllInfo().then(function (res) {
        commit('SET_USERINFO', saveUserInfo(res.data));
        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  // 设置状态
  setLoginStatus: function setLoginStatus(_ref3, query) {
    var commit = _ref3.commit;

    if (query === 0 || query === 1) {
      // 上线打开注释，本地调试注释掉，保持信息最新
      removeToken();
      removeUserInfo();
    } // 设置不同的登录状态


    commit('SET_LOGIN_STATUS', saveLoginStatus(query));
  },
  // 登出
  fedLogOut: function fedLogOut() {
    // 删除token，用户信息，登陆状态
    removeToken();
    removeUserInfo();
    removeLoginStatus();
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};